import React, { FC, useEffect, useState } from 'react';
import { isAllowedToEditTasksByWOStatus } from '../../utils/WorkOrderUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { Button, message } from 'antd';
import { connect } from 'react-redux';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	taskItemsRestCrudThunksForBuyer,
	taskItemsRestCrudThunksForSupplier,
} from '../../thunks/task_items_thunks';

const AddTasksButton: FC<any> = ({
	workOrder,
	tasksSectionVisible,
	showAddTasks,

	currentUser,
	countTaskItems,
}): React.ReactElement => {
	const [countLoading, setCountLoading] = useState(false);
	const [tasksExist, setTaskExist] = useState(false);

	useEffect(() => {
		if (!workOrder.id) return;

		setCountLoading(true);
		countTaskItems({ workOrderId: workOrder.id })
			.then((c) => {
				setTaskExist(c > 0);
				c > 0 && showAddTasks();
			})
			.catch(message.error)
			.finally(() => setCountLoading(false));
	}, [workOrder.id]);

	const noExisitngTasks = !countLoading && !tasksExist;

	return isAllowedToEditTasksByWOStatus(workOrder, currentUser) &&
		!tasksSectionVisible &&
		noExisitngTasks ? (
		<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_WO_TASKS}>
			<Button className="list_button mr-2" size="small" type="link" onClick={showAddTasks}>
				Add Tasks
			</Button>
		</AccessPermissionChecker>
	) : null;
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	countTaskItems: (params, countName = null) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? taskItemsRestCrudThunksForSupplier.countBy(params, countName)
				: taskItemsRestCrudThunksForBuyer.countBy(params, countName)
		),
});

const ComponentWithoutUserType = connect(mapStateToProps, mapDispatchToProps)(AddTasksButton);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
		companyConfig: (state as any).company_config.detail,
	}),
	() => ({})
)(ComponentWithoutUserType);
